import {Route, Redirect, Switch} from "react-router-dom";
import React, {Suspense, lazy, Fragment, useEffect, useState} from 'react';

import {
    ToastContainer,
} from 'react-toastify';
import {getGeneralSettings} from "../Common/Appcommon";
import Dashboard from "../Components/Dashboard";
import Leads from "../Components/Leads";
import LegacyLeads from "../Components/Legacy/Leads";
import Login from "../Components/Login";
import Settings from "../Components/Settings";
import Messages from "../Components/Messages";
import Inbox from "../Components/Inbox";
import Templates from "../Components/Templates";
import DeliveryLogs from "../Components/Analytics";
import Campaigns from "../Components/Campaigns";
import Automations from "../Components/Automations";
import ChatBot from "../Components/Chatbot";
import Form from "../Components/Leads/Form";
import Import from "../Components/Import";
import Tag from "../Components/Tags";
import LegacyActivities from "../Components/Legacy/Activities";
import LegacyDashboard from "../Components/Legacy/Dashboard";
import GlobalSearch from "../Components/Legacy/Search";
import LegacyReports from "../Components/Legacy/Reports";
import LegacyMapview from "../Components/Legacy/Mapview";
import ViewBuilder from "../Components/Search/ViewBuilder";
import LegacyCustomForms from "../Components/Legacy/CustomForms";
import Subscription from "../Components/Subscription";
import CallLogReport from "../Components/CallLogReportes/index";
import TopperReport from "../Components/CallLogReportes/Analysis/index";
import withUseFormHook from "../Common/withUseFormHook";
import CampaignOperations from "../Components/Campaigns/CampaignOperations";
import AutomationOperations from "../Components/Automations/AutomationOperations";
import QuickReplyEdit from "../Components/QuickReply/QuickReplyEdit";
import LegacyCallLog from "../Components/Settings/LegacySettings/LegacyCallLog";
import MobileLogin from "../Components/Login/MobileLogin";
import WorkFlow from "../Components/Workflow";
import WorkFlowOperations from "../Components/Workflow/WorkflowOperations";
import LegacyAttendance from "../Components/Settings/LegacySettings/LegacyAttendance";
import LegacyFieldVisits from "../Components/Settings/LegacySettings/LegacyFieldVisits";
import PartnerPopUp from "../Components/Settings/LegacySettings/LegacyPartnerPopup";
import LegacyAttendanceReport from "../Components/Settings/LegacySettings/LegacyAttendanceReport";
import Onboarding from "../Components/Onboarding";
import Plans from "../Components/Plans/Index";
import LegacyCustomMenus from "../Components/Settings/LegacySettings/LegacyCustomMenus";
import RCSCampaigns from "../Components/Settings/RCS/RCSCampaigns";
import RCSCampaignOperations from "../Components/Settings/RCS/RCSCampaignOperations";

//const CampaignRoutes = lazy(() => import("../Components/Campaigns/CampaignRoutes"));
const AutomationRoutes = lazy(() => import("../Components/Automations/AutomationRoutes"));
const WebsiteWidget = lazy(() => import("../Components/Settings/Integrations/IntegrationWidgets/WebsiteWidget"));
const chatBotRoutes = lazy(() => import("../Components/QuickReply/QuickReplyRoutes"));

const AppMain = () => {
    const [isDisableRightClickNeeded, setIsDisableRightClickNeeded] = useState(false);
    const [isCopyDisabled, setIsCopyDisabled] = useState(false);

    useEffect(() => {
        async function getDisableRightNeeded() {
            let setting = await getGeneralSettings("DISABLE_RIGHT_CLICK_GLOBALLY", true);
            setIsDisableRightClickNeeded(setting !== "" && setting != null && setting !== undefined);
        }
        getDisableRightNeeded();
        async function getCopyDisableSetting() {
            let setting = await getGeneralSettings("IS_COPY_DISABLE", true); 
            setIsCopyDisabled(setting !== "" && setting != null && setting !== undefined);
        }
        getCopyDisableSetting();
    }, []);

    useEffect(() => {
        if (!isDisableRightClickNeeded) return;
        const disableRightClick = (e) => {
            e.preventDefault();
        };
        document.addEventListener("contextmenu", disableRightClick);
        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
        };
    }, [isDisableRightClickNeeded]);

    useEffect(() => {
        if (!isCopyDisabled) return;

        const isEditable = (el) => {
            return el && (
                el.tagName === "INPUT" ||
                el.tagName === "TEXTAREA" ||
                el.tagName === "SELECT" ||
                el.isContentEditable
            );
        };

        const preventSelectStart = (e) => {
            if (!isEditable(e.target)) {
                e.preventDefault();
            }
        };

        const preventCopy = (e) => {
            if (!isEditable(e.target)) {
                e.preventDefault();
            }
        };

        const preventKeydown = (e) => {
            if (!(e.ctrlKey || e.metaKey)) return;
            const key = e.key.toLowerCase();
            if ((key === "a" || key === "c") && !isEditable(document.activeElement)) {
                e.preventDefault();
            }
        };

        document.addEventListener("selectstart", preventSelectStart);
        document.addEventListener("copy", preventCopy);
        document.addEventListener("cut", preventCopy);
        document.addEventListener("keydown", preventKeydown);
        document.body.style.userSelect = "none";
        document.body.style.webkitUserSelect = "none";
        document.body.style.msUserSelect = "none";

        return () => {
            document.removeEventListener("selectstart", preventSelectStart);
            document.removeEventListener("copy", preventCopy);
            document.removeEventListener("cut", preventCopy);
            document.removeEventListener("keydown", preventKeydown);
            document.body.style.userSelect = "";
            document.body.style.webkitUserSelect = "";
            document.body.style.msUserSelect = "";
        };
    }, [isCopyDisabled]);

    return (
        <Fragment>

            {/* Components */}

            <Suspense fallback={<div></div>
                /*<div className="loader-container">
                    <div className="loader-container-inner">
                        <h6 className="mt-5">
                            Please wait while we load all the Components examples
                            <small>Because this is a demonstration we load at once all the Components examples. This
                                wouldn't happen in a real live app!</small>
                        </h6>
                    </div>
                </div>
                <!--<Route path="/leads" component={Leads}/>-->

                */
            }>
                </Suspense>
            
                <Switch>
            <Route exact path="/login_check" component={Login}/>
            <Route path="/leads" component={Leads}/>
            <Route path="/dashboard_new" component={Dashboard}/>
            <Route exact path="/crm" component={LegacyDashboard}/>
            <Route exact path="/crmsearch" component={GlobalSearch}/>
            <Route exact path="/calls" component={LegacyCallLog}/>
            <Route exact path="/fieldvisits" component={LegacyFieldVisits}/>
            <Route exact path="/attendance" component={LegacyAttendance}/>
            <Route exact path="/crm?form=maplocator" component={LegacyMapview}/>
            <Route exact path="/attendancereport" component={LegacyAttendanceReport}/>
            <Route exact path="/partners" component={PartnerPopUp}/>
            <Route path="/new/:formlabel/:formname" component={Form}/>
            <Route path="/edit/:formlabel/:formname/:id" component={Form}/>
            <Route path="/settings/:navType?/:tabName?/edit/:formlabel?/:formname?/:id?" component={Settings}/>
            <Route path="/settings/:navType?/:tabName?/new/:formlabel?/:formname?/:id?" component={Settings}/>
            <Route path="/settings/:navType?/:tabName?/:id?" component={Settings}/>
            {/* <Route path="/settings" component={Settings}/> */}
            <Route path="/messages" component={Messages}/>
            <Route path="/inbox" component={Inbox}/>
            <Route path="/campaigns" component={Campaigns}/>
            <Route path="/automations" component={Automations}/>
            <Route path="/templates" component={Templates}/>
            <Route path="/deliverylogs" component={DeliveryLogs}/>
            <Route 
                path="/deliverylog/:type?/:id?/:status?" 
                component={DeliveryLogs} 
            />
            <Route path="/chatwidget/:id" component={WebsiteWidget}/>
            {/* <Route path="/campaign" component={CampaignRoutes}/> */}
            {/* <Route path="/automation" component={AutomationRoutes}/> */}
            {/* <Route path="/chat" component={chatBotRoutes} /> */}
            <Route path={`/campaign/new`} component={withUseFormHook(CampaignOperations)}/>
            <Route path={`/campaign/edit/:id`} component={withUseFormHook(CampaignOperations)}/>
            <Route path={`/automation/new`} component={withUseFormHook(AutomationOperations, true)}/>
            <Route path={`/automation/edit/:id`} component={withUseFormHook(AutomationOperations, true)}/>
            <Route path="/chatbots" component={ChatBot} />
            <Route path={`/chatbot/new`} component={withUseFormHook(QuickReplyEdit)}/>
            <Route path={`/chatbot/edit/:id`} component={withUseFormHook(QuickReplyEdit)}/>
            <Route path="/import/:form" component={Import} />
            <Route path="/tags" component={Tag} />
            <Route exact path="/:form/viewbuilder/:id" component={ViewBuilder} />
            <Route path="/subscription/:subscriptiontype?" component={Subscription}/>
            <Route path="/callreports" component={CallLogReport}/>
            <Route path="/calltoppers" component={TopperReport}/>
            <Route path="/workflows" component={WorkFlow}/>
            <Route path={`/workflow/new`} component={withUseFormHook(WorkFlowOperations, true)}/>
            <Route path={`/workflow/edit/:id`} component={withUseFormHook(WorkFlowOperations, true)}/>
            <Route exact path="/mobile_login/:appid/:username/:password" component={MobileLogin}/>
            <Route path="/onboarding" component={Onboarding}/>
            <Route path="/plans" component={Plans}/>
            <Route path="/rcscampaigns" component={RCSCampaigns}/>
            <Route path="/rcscampaigns/new" component={RCSCampaignOperations}/>
            <Route path="/rcscampaigns/edit/:id" component={RCSCampaignOperations}/>
            <Route exact path="/custom/:iurl*" component={LegacyCustomMenus}/>
            <Route exact path="/" render={() => (
                <Redirect to="/login_check"/>
            )}/>
            <Route exact path="*" render={() => (
                <Redirect to="/login_check"/>
            )}/>
            </Switch>
            <ToastContainer/>
        </Fragment>
    )
}

export default AppMain;
